"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Lock_1 = __importDefault(require("@mui/icons-material/Lock"));
const material_1 = require("@mui/material");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const strings_1 = require("../../../../../constants/strings");
const sessionQuery_1 = require("../../../../../queries/sessionQuery");
const phoneNumberUtils_1 = require("../../../../../utils/phoneNumberUtils");
const zustandStore_1 = require("../../../../../zustandStore");
const formWrapper_1 = __importDefault(require("../../hsbc/formWrapper"));
const useValidation_1 = require("../../hsbc/hooks/useValidation");
const formInput_1 = __importDefault(require("../../hsbc/steps/common/formInput"));
const validationSchema_1 = require("../../hsbc/steps/invitationRegistration/step_1/validationSchema");
const enterValidationCode_1 = __importDefault(require("./enterValidationCode"));
const logger = (0, pino_1.default)();
const VerifyPhoneSetupForm = () => {
    const { validateField, clearFieldError, fieldErrors, validateAllSchema } = (0, useValidation_1.useValidation)();
    const { steps, setPageLoading, setNotification } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const [showSmsCodeComponent, setShowSmsCodeComponent] = (0, react_1.useState)(false);
    const [formState, setFormState] = (0, react_1.useState)(steps.data?.phoneSetup?.phoneDetails ||
        steps.data?.mfaSms?.phoneDetails || {
        phoneCountryCode: '',
        phoneNumber: '',
        fullPhoneNumber: '',
    });
    const askForSmsCod = (0, sessionQuery_1.useAskForSmsCodeQuery)();
    const maskedPhoneNumber = (0, phoneNumberUtils_1.maskPhoneNumber)(formState.phoneCountryCode, formState.phoneNumber);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => {
            const updatedState = { ...prev, [name]: value };
            clearFieldError(name);
            return updatedState;
        });
    };
    const handleBlur = (e) => {
        if (e) {
            const { name = '' } = e.target;
            validateField(validationSchema_1.phoneDetailsSchema, name, formState);
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        validateAllSchema(validationSchema_1.phoneDetailsSchema, formState);
        setPageLoading(true);
        askForSmsCod.mutate(void 0, {
            onSuccess: () => {
                setShowSmsCodeComponent(true);
            },
            onError: error => {
                setShowSmsCodeComponent(false);
                logger.error({ error });
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: 'Sorry, we are having technical difficulties. Please try again later.',
                    },
                ]);
            },
            onSettled: () => {
                setPageLoading(false);
            },
        });
    };
    return showSmsCodeComponent ? ((0, jsx_runtime_1.jsx)(enterValidationCode_1.default, { challengeName: "SOFTWARE_TOKEN_MFA" })) : ((0, jsx_runtime_1.jsxs)(formWrapper_1.default, { style: { width: 'auto', border: 'none', paddingTop: 0 }, formName: "Verify your phone number", onSubmit: handleSubmit, submitButton: {
            label: 'Send Code',
            isDisabled: !validationSchema_1.phoneDetailsSchema.safeParse(formState).success,
        }, isFormPending: askForSmsCod.isPending, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", sx: { marginBottom: '16px' }, children: "Tradeshift Go requires two-step authentication when you use virtual cards in order to keep your account and payments secure." }), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Phone number", type: "tel", name: "phoneNumber", value: maskedPhoneNumber, error: fieldErrors['phoneDetails.fullPhoneNumber'], onChange: handleInputChange, onBlur: handleBlur, readOnly: true, endAdornment: (0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(Lock_1.default, { color: "disabled" }) }), placeholder: "(+45) 12 34 56 78" })] }));
};
exports.default = VerifyPhoneSetupForm;
